import { createGenericDispatcher } from '../../../action/action-dispatcher-factory';
import { openOrCloseGlobalDialog } from '../../../action/dialog/global-dialog';

import * as Api from '../../../api/api';

export const createSurvey = (orgId: number, survey: CreateSurveyRequest) =>
  createGenericDispatcher<Survey>({
    name: 'CREATE_SURVEY',
    loadFunction: () =>
      Api.post('/surveys', {
        body: JSON.stringify({
          ...survey,
        }),
      }),
    args: { orgId, survey },
    onSuccess: (dispatch, _getState, data) => {
      if (data.numberOfEmployeesNotSentASurvey && data.numberOfEmployeesNotSentASurvey > 0) {
        dispatch(
          openOrCloseGlobalDialog('surveyNotSentWarning', true, {
            orgId: data.orgId,
            surveyId: data.surveyId,
            numberOfEmployeesNotSentASurvey: data.numberOfEmployeesNotSentASurvey,
          }),
        );
      }
    },
  });
